<template>
  <!--
      作者：fzf
      时间：2025-06-16
      描述：会员-用户列表-会员等级变更
  -->
  <div>
  <el-dialog title="会员等级变更" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">

      <el-form-item label="等级" :label-width="formLabelWidth">
         <el-select v-model="form.grade_id" placeholder="-请选择等级-">
           <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
         </el-select>
       </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
         open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        grade4:0,
      };
    },
    props: ['open_edit_level', 'form', 'gradeList'],
    created() {
      this.dialogVisible = this.open_edit_level;
    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.form;
        params.grade4 = self.grade4;
        UserApi.edituserlevel(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        console.log(e)
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/GradeLevel.vue